import './bootstrap';
import '../css/app.css';

import { createApp, h } from 'vue';
import {createInertiaApp} from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import dayjs from 'dayjs';

import duration from 'dayjs/plugin/duration';
import * as Sentry from "@sentry/vue";
dayjs.extend(duration);

const appName = import.meta.env.VITE_APP_NAME || 'Laravel';
const appEnv = import.meta.env.VITE_APP_ENV || 'local';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const app = createApp({ render: () => h(App, props) })
            .use(plugin)
            .use(ZiggyVue);

        if (appEnv !== 'local') {
            Sentry.init({
                app,
                dsn: import.meta.env.VITE_SENTRY_VUE_DSN,
                dataCollection: {
                    // To disable sending user data and HTTP bodies, uncomment the lines below. For more info visit:
                    // https://docs.sentry.io/platforms/javascript/guides/vue/configuration/options/#dataCollection
                    // userInfo: false,
                    // httpBodies: []
                },
                integrations: [
                    Sentry.browserTracingIntegration(),
                    Sentry.replayIntegration()
                ],
                // Tracing
                tracesSampleRate: 1.0, // Capture 100% of the transactions
                // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                tracePropagationTargets: ["pegasus-6.test"],
                // Session Replay
                replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
                replaysOnErrorSampleRate: 1.0 // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
            });
        }

        app.mount(el);

        return app;
    },
    progress: {
        color: '#4B5563',
    },
});
